"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrightness = exports.getUniqueItemsByKey = void 0;
// @ts-ignore
const lodash_1 = require("lodash");
// @ts-ignore
const color_rgba_1 = __importDefault(require("color-rgba"));
const getUniqueItemsByKey = (items, key = 'id') => {
    const uniqueKeys = Array.from(new Set(items.filter((item) => !!item).map((item) => (0, lodash_1.get)(item, key, null))));
    return items.reduce((returnedItems, item) => {
        const itemKey = (0, lodash_1.get)(item, key, null);
        return item &&
            itemKey &&
            uniqueKeys.indexOf(itemKey) > -1 &&
            returnedItems.findIndex((i) => (0, lodash_1.get)(i, key, null) === itemKey) === -1
            ? [...returnedItems, item]
            : returnedItems;
    }, []);
};
exports.getUniqueItemsByKey = getUniqueItemsByKey;
/**
 * Using the formula from http://alienryderflex.com/hsp.html, calculate the perceived
 * brightness of the provided color.
 */
const getBrightness = (color) => {
    let [red, green, blue] = (0, color_rgba_1.default)(color);
    return Math.sqrt(0.299 * red ** 2 + 0.587 * green ** 2 + 0.114 * blue ** 2);
};
exports.getBrightness = getBrightness;
//# sourceMappingURL=helpers.js.map